import { featured } from "../../data/Data"
import { useTranslation } from 'react-i18next'
import { useNavigate } from "react-router-dom"
import "./Featured.scss"

const FeaturedCard = () => {
  const { t } = useTranslation('services')
  const navigate = useNavigate()
  const redirectToServicePage = (event: React.MouseEvent<HTMLAnchorElement>, path: string) => {
    if(path != ""){
      if(path.slice(0, 5) === "https"){
        window.open(path, '_blank')
      }
      else{
        navigate(path)
        window.scrollTo(0, 0)
      } 
    }
  }
  return (
    <>
      <div className='services__grid'>
        {featured.map((items, index) => (
          <div className='service-card' key={index} onClick={(event:any) => redirectToServicePage(event, items.path)}>
            <div className='service-card__number'>{String(index + 1).padStart(2, '0')}</div>
            <span className='service-card__rule' />
            <h3 className='service-card__name'>{t(items.name)}</h3>
            <p className='service-card__subtitle'>{t(items.total)}</p>
          </div>
        ))}
      </div>
    </>
  )
}

export default FeaturedCard
